export default __webpack_public_path__ + "static/media/timeElapsed.cc2fcfff.svg";